import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';

const EmptyState = ({
  icon: Icon,
  title = 'Nothing here yet',
  subtitle = 'Get started by creating your first item.',
  actionLabel,
  onAction,
  height,
}) => {
  return (
    <Paper sx={{ p: 4, borderRadius: 2, height }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: height || 240, textAlign: 'center' }}>
        {Icon && <Icon sx={{ fontSize: 56, color: 'text.secondary', mb: 2 }} />}
        <Typography variant="h6" color="text.secondary" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {subtitle}
        </Typography>
        {actionLabel && onAction && (
          <Button variant="contained" onClick={onAction}>{actionLabel}</Button>
        )}
      </Box>
    </Paper>
  );
};

export default EmptyState;


